// Header old
// import { Component, OnInit } from '@angular/core';
// import {
//   ReactiveFormsModule,
//   FormBuilder,
//   FormGroup,
//   Validators,
// } from '@angular/forms';
// import { AuthenticationService } from '../../_services';
// import { ConstantsBetaService } from '../../_services/constants-beta.service';
// import { ActivatedRoute, Router } from '@angular/router';
// import { ToastrService } from 'ngx-toastr';
// import { TableService } from '../../_services/table.service';
// // import { PrimeNGConfig, FilterMatchMode } from 'primeng/api';
// // import * as md5 from 'md5';
// import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
// import { CommonModule } from '@angular/common';
// import { DialogModule } from 'primeng/dialog';
// import { MessagesModule } from 'primeng/messages';

// @Component({
//   selector: 'app-header',
//   imports: [
//     CommonModule,
//     NgbCollapseModule,
//     DialogModule,
//     ReactiveFormsModule,
//     MessagesModule,
//   ],
//   templateUrl: './header.component.html',
//   styleUrl: './header.component.scss',
// })
// export class HeaderComponent implements OnInit {
//   public isCollapsed: boolean = true;
//   currentUser: any;
//   accessKey: string = '';
//   isLoggedIn: boolean = false;
//   isShowLoginDialog: boolean = false;
//   loginForm!: FormGroup;
//   msgs: any[] = [];

//   constructor(
//     // private primengConfig: PrimeNGConfig,
//     private authenticationService: AuthenticationService,
//     private _constant: ConstantsBetaService,
//     private route: ActivatedRoute,
//     private router: Router,
//     private fb: FormBuilder,
//     private toastr: ToastrService,
//     private tableService: TableService
//   ) {}

//   ngOnInit() {
//     //////// PRIMNG CONFIGURATION //////
//     // this.primengConfig.ripple = true;
//     // this.primengConfig.filterMatchModeOptions = {
//     //   text: [
//     //     FilterMatchMode.CONTAINS,
//     //     FilterMatchMode.STARTS_WITH,
//     //     FilterMatchMode.NOT_CONTAINS,
//     //     FilterMatchMode.ENDS_WITH,
//     //     FilterMatchMode.EQUALS,
//     //     FilterMatchMode.NOT_EQUALS,
//     //   ],
//     //   numeric: [
//     //     FilterMatchMode.EQUALS,
//     //     FilterMatchMode.NOT_EQUALS,
//     //     FilterMatchMode.LESS_THAN,
//     //     FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
//     //     FilterMatchMode.GREATER_THAN,
//     //     FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
//     //   ],
//     //   date: [
//     //     FilterMatchMode.DATE_IS,
//     //     FilterMatchMode.DATE_IS_NOT,
//     //     FilterMatchMode.DATE_BEFORE,
//     //     FilterMatchMode.DATE_AFTER,
//     //   ],
//     // };

//     //this.msgs.push({severity:'error', summary:'Error', detail:'Invalid Username or Password !'});
//     this.loginForm = this.fb.group({
//       username: ['', Validators.required],
//       password: ['', Validators.required],
//     });

//     this.authenticationService.currentUser.subscribe((x) => {
//       this.currentUser = x;
//       if (this.currentUser != null) {
//         if (this.currentUser.username != 'chemrobouser') {
//           this._constant.isLoggedIn = true;
//           this.isLoggedIn = true;
//           this.tableService.sendLoggedIn(this._constant.isLoggedIn);
//           this._constant.accessKey = btoa(this.currentUser.userid);
//         } else {
//           this._constant.isLoggedIn = false;
//           this.tableService.sendLoggedIn(this._constant.isLoggedIn);
//           this.isLoggedIn = false;
//         }
//       }
//     });
//     this.accessKey = this._constant.accessKey;
//   }

//   backtotop() {
//     document.body.scrollTop = document.documentElement.scrollTop = 0;
//   }

//   login() {
//     // let password = md5(this.loginForm.controls['password'].value);
//     let password = '25d55ad283aa400af464c76d713c07ad';
//     this.authenticationService
//       .user_login(this.loginForm.controls['username'].value, password)
//       .subscribe(
//         (res) => {
//           if (res != null) {
//             this.isShowLoginDialog = false;
//             //this._constant.GoToMainUrl();
//             this._constant.accessKey = btoa(res.userid);
//             // debugger;
//             this.accessKey = this._constant.accessKey;
//             this._constant.isLoggedIn = true;
//             this.tableService.sendLoggedIn(this._constant.isLoggedIn);

//             this.toastr.success('Logged In Successfully', res.username);
//             //window.location.reload();
//           } else {
//             ////console.log(`user logged in - ${res.username}`);
//             //this.Bind_Dropdowns();
//             //window.location.reload();
//             this._constant.isLoggedIn = false;
//             this.tableService.sendLoggedIn(this._constant.isLoggedIn);
//             this.msgs = [];
//             this.msgs.push({
//               severity: 'error',
//               summary: 'Error',
//               detail: 'Invalid Username or Password !',
//             });
//           }
//         },
//         (error) => {
//           //console.log(error);
//           //this._constant.GoToMainUrl();
//           this.msgs = [];
//           this.msgs.push({
//             severity: 'error',
//             summary: 'Error',
//             detail: 'Invalid Username or Password !',
//           });
//         }
//       );
//   }

//   logout() {
//     this.isLoggedIn = false;
//     this._constant.isLoggedIn = false;
//     this.tableService.sendLoggedIn(this._constant.isLoggedIn);
//     let currentaccesskey = this.route.snapshot.queryParams['access_key'];
//     let newurlroute = this.router.url.replace(
//       `?access_key=${currentaccesskey}`,
//       ''
//     );
//     this.toastr.success('Logged Out Successfully', this.currentUser.username);
//     localStorage.removeItem('currentUser');
//     this.accessKey = '';
//     this.currentUser = null;
//     this.router.navigateByUrl(newurlroute);
//     //this._constant.GoToMainUrl();
//   }

//   toggleActive(id: string) {
//     //Remove Active
//     document
//       .getElementsByClassName('nav-item active')[0]
//       .classList.remove('active');
//     var link = document.getElementById(id)?.parentElement;
//     if (link) {
//       link.classList.add('active');
//     }
//   }
// }

// Header new
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthenticationService } from '../../_services';
import { DatasearchService } from '../../_services/datasearch.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { BusyService } from '../../_services/busy.service';
import { MessageService } from 'primeng/api';
import { AuthenticationBetaNewService } from '../../_services/authentication-beta-new.service';
import { GlobalService } from '../../_services/global.service';
import { AppLinks } from '../../app-links'; // @ts-ignore
import { RecaptchaModule, ReCaptchaV2Component } from 'ng-recaptcha';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
import { DatasearchBetaNewService } from '../../_services/datasearch-beta-new.service';
import * as bootstrap from 'bootstrap';
import md5 from 'md5';
import { ConstantsBetaService } from '../../_services/constants-beta.service';
import { TableService } from '../../_services/table.service';

declare var $: any;

@Component({
  selector: 'app-header',
  imports: [
    ReactiveFormsModule,
    DropdownModule,
    NgIf,
    CommonModule,
    RouterLink,
    NgFor,
    FormsModule,
    RecaptchaModule,
    ToastrModule,
    TooltipModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Input() transparent: boolean = false;
  @Input() homePage: boolean = false;
  @ViewChild('recaptchaRef') recaptchaRef!: ReCaptchaV2Component;
  @ViewChild('userSettingDialog') userSettingDialog!: ElementRef;
  lists: any = [];
  labels: { id: number; profession: string; checked: boolean }[] = [];
  ids: number[] = [];
  signInForm!: FormGroup;
  forgotPasswordForm!: FormGroup;
  demorequestForm!: FormGroup;
  signUpForm!: FormGroup;
  accessKey: string = '';
  selectedCountsignup: number = 0;
  selectedCountdemo: number = 0;
  languages: any[] = [];
  selectedLanguage: any = {};
  errorMessage: string = '';
  showSecondForm: boolean = false;
  showProducts = false;
  descDropdown = false;
  servicesDropdown = false;
  overAgroProducts = false;
  overProductsDropdown = false;
  overHeaderDesc = false;
  overDescDropdown = false;
  overHeaderservices = false;
  overServicesDropdown = false;
  showMenu = false;
  selectedMenu = '';
  headerData: any = {};
  successMessage: string = '';
  countries: any[] = [];
  originalCountries: any[] = [];
  details = ['Profession', 'Professional Detail', 'Personal Detail'];
  showThirdForm: boolean = false;
  showWarn: boolean = false;
  isSignedIn = false;
  isLoggedIn: boolean = false;
  public appLinks = AppLinks;
  sentEmail: string = '';
  errorMessageforgot: string = '';
  isSubmitted: boolean = false;
  dropdownOpen = false;
  userSetting = false;
  selectedBrochure: any;
  brochures: any[] = [];
  recaptchaResponse: string | null = null;
  formSubmitted = false;

  password: any = 'password';
  show = false;

  user_ip: string = '';
  address: string = '';

  constructor(
    private fb: FormBuilder,
    private authenticationService: AuthenticationBetaNewService,
    private authenticationServiceOld: AuthenticationService,
    private datasearch: DatasearchBetaNewService,
    private globalService: GlobalService,
    private router: Router,
    private busyService: BusyService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private _constant: ConstantsBetaService,
    private tableService: TableService
  ) {
      this.setIpandLocation();
  }

  logoUrl = 'https://www.chemrobotics.com/agropat/uploads/thumbnail/';

  recaptchaSiteKey = '6Lfab7oqAAAAAHad-9wNzez0wmMNevQBclRzL8BC'; // live
  // recaptchaSiteKey = '6Lcpo3QqAAAAAIKDJyb4lg4QKCWMuQMA7VxbP9uD'; // local

  userData: any = {};
  verticals: { vertical: string; checked: boolean }[] = [
    { vertical: 'AgroPat Ultimate Discovery Suite', checked: false },
    { vertical: 'AgroPat Ultimate Generic Suite', checked: false },
    { vertical: 'Technical Route', checked: false },
    { vertical: 'ChemiTracker - A Supplier Guide', checked: false },
    { vertical: 'Global MRL Database', checked: false },
    { vertical: 'QuikPatent - Constraining Patent Guide', checked: false },
    { vertical: 'Indian Pesticide Database', checked: false },
    { vertical: 'Global Agro Product Directory', checked: false },
    { vertical: 'Company Directory', checked: false },
    { vertical: 'PharmVetPat Ultimate', checked: false },
    { vertical: 'AgroPharm XIM DB Beta', checked: false },
    { vertical: 'Supplementary Protection Certificate', checked: false },
  ];
  copyMessage: string | undefined;

  ngOnInit() {
    this.logoUrl = this.datasearch.constants ? this.datasearch.constants.ApiUrl + '/uploads/layout-logos/' : 'http://localhost:5001/uploads/layout-logos/';
    this.checkUser();
    this.getHeaderData();
    this.globalService.getOpenSignInModal().subscribe((val: any) => {
      val ? this.openSignInForm() : '';
    });
    this.globalService.getOpenSignUpModal().subscribe((val: any) => {
      val ? this.openSignUpForm() : '';
    });
    this.authenticationService.getLoginUser().subscribe((val: any) => {
      this.isSignedIn = val;
    });
    this.authenticationService.getCurrentUserSubject().subscribe((val: any) => {
      this.userData = val;
    });

    setTimeout(() => {
      this.onWindowScroll();
    }, 0);
    this.getLabels();
    this.initialiseForm();
    this.updateSelectedCount();
    this.loadGoogleTranslate();
    this.getList();
    this.loadCountryCodes();
    this.getBrochureData();
  }
  ngAfterViewInit() {
    this.loadGoogleTranslate();
  }
  loadCountryCodes() {
    const uniqueCountries = new Map();
    getCountries().forEach((country: any) => {
      const code = `+${getCountryCallingCode(country)}`;
      const flag = `https://flagcdn.com/16x12/${country.toLowerCase()}.png`;
      if (!uniqueCountries.has(code)) {
        uniqueCountries.set(code, { code, flag });
      }
    });
    this.countries = Array.from(uniqueCountries.values());
  }
  checkUser() {
    let currentuser = localStorage.getItem('currentUser');
    const searchParams = new URLSearchParams(window.location.search);
    this.accessKey = searchParams.get('access_key') || this.route.snapshot.queryParams['access_key'] || '';

    let userobj;
    if (currentuser) {
      this.authenticationService.refreshToken().subscribe(
        (val) => {
          this.authenticationService.getSavedUser();
          this.isLoggedIn = true;

          // New code added (2-1-24 12.50pm)
          this._constant.isLoggedIn = true;
          this.tableService.sendLoggedIn(this._constant.isLoggedIn);
        },
        (err) => {
          console.log(err);
          if (err.statusText === 'Unauthorized') {
            localStorage.removeItem('currentUser');
            this.authenticationService.sendCurrentUserSubject({});
            this.authenticationService.sendLoginUser(false);
          }
        }
      );
      let currentUser2 = JSON.parse(currentuser);
      if (currentUser2 != null && currentUser2.userid) {
        this.accessKey = btoa(currentUser2.userid);
      }
    } else {
      if (this.accessKey != '' && currentuser == null) {
        this.authenticationService.auto_login2(this.accessKey).subscribe(
          (res) => {
            if (res && res.status !== false && res.status !== 'false' && (res.token || res.userid || res.status === true)) {
              const url = new URL(window.location.href);
              url.searchParams.delete('access_key');
              window.location.href = url.pathname + url.search;
            } else {
              console.log('Auto login failed or inactive:', res);
            }
          },
          (error: any) => {
            console.log(error);
          }
        );
      }
    }
  }

  loadGoogleTranslate() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      function googleTranslateElementInit() {
        new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
      }
      googleTranslateElementInit();
    `;
  }

  getList() {
    this.lists = [
      'ChemRobotics offers Trial access to users who wish to evaluate ChemRobotics database. Its important to note that ChemRobotics is a premium Database that requires a paid subscription.',
      'According to ChemRobotics Database policy, we kindly request users to register using their official Company Domain email. We regret to inform you that personal email providers such as Gmail, Yahoo and Rediff etc., are not accepted for the Sign-Up process.',
      'To ensure an ideal experience, we kindly ask users to provide accurate and complete details during the Sign-Up process. ChemRobotics support team reviews the information provided. If any incorrect, false, or incomplete information is found, the user may not be granted activation for ChemRobotics trial access.',
      'Once the user has successfully completed the signup process, ChemRobotics support team will review the registration details. Based on their evaluation, the user will receive an activation email directly from ChemRobotics support team.',
    ];
  }

  initialiseForm() {
    this.signInForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
    this.demorequestForm = this.fb.group({
      verticals: [''],
      date: ['', Validators.required],
      time: ['', Validators.required],
      fname: ['', Validators.required],
      lname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      country_code: ['+91', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      job: ['', Validators.required],
      company: ['', Validators.required],
      country: ['', Validators.required],
      industry: ['', Validators.required],
      comment: [''],
      web: ['Agro'],
      source: [''],
      recaptcha: ['', Validators.required],
    });
    this.signUpForm = this.fb.group({
      address: ['', Validators.required],
      company_name: ['', Validators.required],
      country_name: ['', Validators.required],
      gender: ['', Validators.required],
      department_name: ['', Validators.required],
      education: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      firstname: ['', Validators.required],
      industry: ['', Validators.required],
      institute_company: ['', Validators.required],
      lastname: ['', Validators.required],
      mobile_no: ['', [Validators.required]],
      notify_update: ['true', Validators.required],
      occupation: ['', Validators.required],
      password: ['', [Validators.required]],
      pincode: ['', Validators.required],
      state: ['', Validators.required],
      prefix: ['', Validators.required],
      scientific_profession: [[]],
      web: ['Agro'],
    });
  }

  LogoutClick() {
    // New code added (2-1-24 1.20pm)
    this._constant.isLoggedIn = false;
    this.tableService.sendLoggedIn(this._constant.isLoggedIn);
    this.tableService.sendShowTable(false);
    this.authenticationService.logout();
    this.userSetting = false;
    this.accessKey = '';
    this.selectedMenu = '';
    this.isLoggedIn = false;
    const currentRoute = this.router.url;
    this.router.navigate(['/']);
    if (currentRoute === '/profile' || currentRoute === '/edit_profile') {
      this.router.navigate(['/']);
    }
  }
  onBrochureChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const selectedBrochure = target.value;
    if (selectedBrochure) {
      window.open(selectedBrochure, '_blank');
    }
  }
  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  toggleUserSetting(event: MouseEvent): void {
    event.stopPropagation();
    this.userSetting = !this.userSetting;
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const dropdown = document.querySelector(
      '.header_top_left_box1_item_icon1_dropdown'
    );
    const toggle = document.querySelector('.selected-option');

    if (
      dropdown &&
      !dropdown.contains(target) &&
      toggle &&
      !toggle.contains(target)
    ) {
      this.dropdownOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (
      this.userSetting &&
      this.userSettingDialog &&
      !this.userSettingDialog.nativeElement.contains(event.target)
    ) {
      this.userSetting = false;
    }
  }
  getBrochureData() {
    this.datasearch.getBrochure().subscribe(
      (res: any) => {
        const list = res?.data || res?.results;
        if (list && Array.isArray(list)) {
          this.brochures = list.map((brochure: any) => ({
            id: brochure._id || brochure.id,
            fileName: brochure.file_name || brochure.fileName || brochure.title || 'Unknown Brochure',
            brochureUrl: brochure.brochureUrl || brochure.url || (brochure.brochure ? `https://www.chemrobotics.com/agropat/uploads/brochures/${brochure.brochure}` : '#'),
          }));
        }
      },
      (error: any) => {
        console.error('Error fetching brochures: ', error);
      }
    );
  }

  selectBrochure(brochure: any) {
    this.selectedBrochure = brochure;
    this.dropdownOpen = false;

    if (brochure.brochureUrl) {
      window.open(brochure.brochureUrl, '_blank');
    } else {
      console.error('Invalid brochure URL');
    }
  }

  getHeaderData() {
    this.datasearch.getHeader().subscribe(
      (res: any) => {
        if (res && (res.success || res.status)) {
          this.headerData = Array.isArray(res.data) ? res.data[0] : res.data;
        }
      },
      (error: any) => {
        console.error('Error fetching header data', error);
      }
    );
  }
  submitForgotPasswordForm() {
    if (this.forgotPasswordForm.valid && this.recaptchaResponse) {
      this.formSubmitted = true;
      const email = this.forgotPasswordForm.get('email')?.value;
      this.sentEmail = email;
      const formData = new FormData();
      formData.append('username', email);
      formData.append('web', 'Agro');
      this.busyService.busy();
      this.datasearch.sendForgotpswd(formData).subscribe(
        (response: any) => {
          this.busyService.idle();
          this.formSubmitted = false;
          this.forgotmodelclose();
          if (response.status === 'success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Check Email',
              detail: response.message,
              life: 10000,
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: response.message,
              life: 10000,
            });
          }
        },
        (error: any) => {
          this.busyService.idle();
          this.errorMessageforgot =
            'An error occurred while sending the request.';
        }
      );
    } else {
      this.errorMessageforgot = 'Please provide a valid email address.';
    }
  }

  forgotmodelclose() {
    const modalElement = document.getElementById('forgot-password');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      } else {
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
        modalElement.setAttribute('aria-hidden', 'true');
      }
    }

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach((b) => b.remove());
  }
  closeSigninModel() {
    const modalElement = document.getElementById('sign-in');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      } else {
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
        modalElement.setAttribute('aria-hidden', 'true');
      }
    }

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach((b) => b.remove());
  }
  showAlertModal() {
    const alertModalElement = document.getElementById('alertModelforgot');
    if (alertModalElement) {
      $('#alertModelforgot').modal('show');
      setTimeout(() => {
        $('#alertModelforgot').modal('hide');
      }, 5000);
    }
  }

  openInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  submit_signin_form() {
    if (this.signInForm.invalid) {
      this.signInForm.markAllAsTouched();
      return;
    }

    const postdata = {
      username: this.signInForm.value.username,
      password: this.signInForm.value.password,
    };

    this.busyService.busy();

    this.authenticationServiceOld
      .user_login(postdata)
      .subscribe(
        (res) => {
          if (!res || res.status === 'error' || res.status === 'inactive' || res.status === 'suspended' || res.status === 'failed' || res.status === 0 || res.is_active === false || res.is_active === 0 || res.is_active === '0' || res.isActive === false || res.error) {
            this.errorMessage = res?.message || res?.error || 'Access denied: Account is suspended/inactive';
            this.busyService.idle();
            return;
          }

          this.isLoggedIn = true;
          this.busyService.idle();
          this.isSignedIn = true;

          // New code added (2-1-24 12.30pm)
          this._constant.isLoggedIn = true;
          this.tableService.sendLoggedIn(this._constant.isLoggedIn);

          this.closeSignInModal();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        },
        (err) => {
          let msg = err.error?.message || err.error?.error;
          if (!msg && typeof err.error === 'string') {
            try {
              const parsed = JSON.parse(err.error);
              msg = parsed?.message || parsed?.error;
            } catch (e) {
              if (!err.error.includes('Http failure response')) {
                msg = err.error;
              }
            }
          }
          if (!msg && err.message && !err.message.includes('Http failure response')) {
            msg = err.message;
          }
          if (!msg) {
            msg = err.status === 403 ? 'Access forbidden: Invalid credentials or account disabled' : 'Invalid username or password';
          }
          this.errorMessage = msg;
          this.signInForm.reset();
          this.signInForm.markAsUntouched();
          this.busyService.idle();
        }
      );
  }

  previousForm() {
    if (this.showThirdForm) {
      this.showThirdForm = false;
      this.showSecondForm = true;
    } else if (this.showSecondForm) {
      this.showSecondForm = false;
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }
  openSignInForm() {
    const modalElement = document.getElementById('sign-in');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.show();
      }
    }
    this.globalService.sendOpenSignInModal(false);
  }
  openSignUpForm() {
    const modalElement = document.getElementById('sign-up');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.show();
      }
    }
    this.globalService.sendOpenSignInModal(false);
  }

  closeSignInModal() {
    const modalElement = document.getElementById('sign-in');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      } else {
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
        modalElement.setAttribute('aria-hidden', 'true');
      }
    }

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach((b) => b.remove());
  }

  addHttpsIfMissing(url: string): string {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return 'https://' + url;
    }
    return url;
  }

  toggleVerticalChecked(index: number) {
    this.verticals[index].checked = !this.verticals[index].checked;
    this.selectedCountdemo = this.verticals.filter((v) => v.checked).length;
  }
  updateSelectedCount() {
    this.selectedCountdemo = this.verticals.filter(
      (vertical) => vertical.checked
    ).length;
  }
  submit_demo_form() {
    let verticalArr: any = this.verticals
      .filter((str: any) => {
        return str.checked;
      })
      .map((val: any) => {
        return val.vertical;
      });
    verticalArr = verticalArr.join();
    this.demorequestForm.controls['verticals'].setValue(verticalArr);
    this.demorequestForm.value.time += ':00';
    let emailPostData = {
      to: 'support@chemrobotics.com',
      cc: 'greenbookcorp@gmail.com',
      subject: 'Demo Request (Agro)',
      html: `
              <div style="background-color: #ffc702; heigth:30px; text-align: center;">
              <img src="cid:logoImg" alt="Logo">
              </div>
              <div style="background-color: #eee;">
                <p>New demo request received now!</p>                
              </div> 
              <div style="background-color: #eee;">
                <p>Name: <strong>${this.demorequestForm.value.fname} ${this.demorequestForm.value.lname}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Email: <strong>${this.demorequestForm.value.email}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Phone: <strong>${this.demorequestForm.value.phone}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Job: <strong>${this.demorequestForm.value.job}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Company: <strong>${this.demorequestForm.value.company}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Country: <strong>${this.demorequestForm.value.country}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Industry: <strong>${this.demorequestForm.value.industry}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Demo Date: <strong>${this.demorequestForm.value.date}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Demo Time: <strong>${this.demorequestForm.value.time}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Vertical/Platform: <strong>${this.demorequestForm.value.vertical}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Comment: <strong>${this.demorequestForm.value.comment}</strong></p>                
              </div>              
              <hr>
              <div style="background-color: #eee; text-align: center;">
              <p>Copyright 2023 <strong><a href="https://www.chemrobotics.com/">ChemRobotics</a></strong></p>
              <div/>`,
    };

    let postdata: any = {
      demoRequest: this.demorequestForm.value,
      emailPostData: emailPostData,
    };
    this.datasearch.demoRequest(postdata).subscribe(
      (response: any) => {
        this.closeDemoRequestModal();
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  // Handle the reCAPTCHA response
  onCaptchaSuccess(token: string | null) {
    this.recaptchaResponse = token;
    this.startCaptchaResetTimer();
  }
  // Reset reCAPTCHA
  resetCaptcha() {
    this.recaptchaResponse = null;
    this.recaptchaRef.reset();
  }

  startCaptchaResetTimer() {
    setTimeout(() => {
      this.resetCaptcha();
    }, 60000);
  }
  closeDemoRequestModal() {
    const modalElement = document.getElementById('demo-form');
    if (modalElement) {
      $('#demo-form').modal('hide');
    }
  }

  openSignup() {
    this.getLabels();
  }
  getLabels() {
    this.datasearch.getUserprofession().subscribe(
      (res: any) => {
        this.labels = res.data.map((item: any) => ({
          id: item.id,
          profession: item.profession,
          checked: false,
        }));
        this.ids = res.data.map((item: any) => item.id);
      },
      (err: any) => {}
    );
  }

  // sign-up
  updateCount() {
    this.selectedCountsignup = this.labels.filter(
      (profession) => profession.checked
    ).length;
  }
  toggleCheckbox(index: number) {
    this.labels[index].checked = !this.labels[index].checked;
    this.updateCount();
  }

  toggleSecondForm() {
    this.signUpForm.controls['scientific_profession'].setValue(
      this.labels.filter((val) => val.checked).map((val) => val.id)
    );
    this.showSecondForm = !this.showSecondForm;
  }

  isNextButtonEnabled() {
    return this.selectedCountsignup > 0;
  }
  toggleThirdForm() {
    this.isSubmitted = true;
    if (this.showSecondForm) {
      this.signUpForm.controls['scientific_profession'].setValue(
        this.labels.filter((val) => val.checked).map((val) => val.id)
      );
      if (
        this.signUpForm.get('institute_company')?.valid &&
        this.signUpForm.get('department_name')?.valid &&
        this.signUpForm.get('industry')?.valid &&
        this.signUpForm.get('company_name')?.valid &&
        this.signUpForm.get('occupation')?.valid &&
        this.signUpForm.get('country_name')?.valid &&
        this.signUpForm.get('state')?.valid &&
        this.signUpForm.get('address')?.valid &&
        this.signUpForm.get('pincode')?.valid
      ) {
        this.showSecondForm = false;
        this.showThirdForm = true;
        this.isSubmitted = false;
      } else {
        this.signUpForm.markAllAsTouched();
      }
    } else if (this.showThirdForm) {
      if (this.signUpForm.valid) {
      } else {
        this.signUpForm.markAllAsTouched();
      }
    }
  }

  submit_signup_form() {
    this.isSubmitted = true;
    this.busyService.busy();

    // Check if the form is valid and if reCAPTCHA has a response
    if (this.signUpForm.valid && this.recaptchaResponse) {
      let postData = null;
      postData = this.signUpForm.value;

      this.datasearch.sendSignup(postData).subscribe(
        (response: any) => {
          this.busyService.idle();
          if (response.status == 'error') {
            alert(response.message);
          } else {
            this.successMessage = 'Thank you for registering with ChemRobotics';
            this.router.navigate(['/']);
            this.signUpForm.reset();
            this.isSubmitted = false;
            this.closeSignUpModal();
            this.authenticationService.sendCurrentUserSubject(response);
          }
        },
        (error) => {
          this.busyService.idle();
          if (error.error && error.error.message) {
            this.errorMessage = error.error.message;
          } else {
            this.errorMessage =
              'An unexpected error occurred. Please try again later.';
          }
          if (error.status == 'error') {
            console.log('123', error.status);
          }
          this.signUpForm.reset();
          this.signUpForm.markAsUntouched();
        }
      );
    } else {
      this.busyService.idle();

      this.signUpForm.markAllAsTouched();
      this.errorMessage = this.getErrorMessages();
    }
  }

  getErrorMessages() {
    let errorMessages = '';

    Object.keys(this.signUpForm.controls).forEach((key) => {
      const controlErrors = this.signUpForm.get(key)?.errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach((errorKey) => {
          errorMessages += `${key}: ${errorKey} error\n`;
        });
      }
    });

    return (
      errorMessages ||
      'Please fill in all required fields correctly and complete reCAPTCHA.'
    );
  }

  closeSignUpModal() {
    const modalElement = document.getElementById('sign-up');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      } else {
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
        modalElement.setAttribute('aria-hidden', 'true');
      }
    }

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach((b) => b.remove());
    window.location.reload();
  }
  enterHeader() {
    this.overProductsDropdown = true;
    this.showDropdown();
  }

  leaveHeader() {
    this.overProductsDropdown = false;
    setTimeout(() => {
      this.hideDropdown();
    }, 10);
  }

  enterProductBox() {
    this.overAgroProducts = true;
    this.showDropdown();
  }

  leaveProductBox() {
    this.overAgroProducts = false;
    setTimeout(() => {
      this.hideDropdown();
    }, 10);
  }

  showDropdown() {
    this.showProducts = true;
  }
  atLeastOneCheckboxRequired(formArray: FormArray) {
    const isChecked = formArray.controls.some((control) => control.value);
    return isChecked ? null : { atLeastOneCheckboxRequired: true };
  }
  hideDropdown() {
    if (!this.overProductsDropdown && !this.overAgroProducts) {
      this.showProducts = false;
    }
  }

  enterHeaderDesc() {
    this.overHeaderDesc = true;
  }

  leaveHeaderDesc() {
    this.overHeaderDesc = false;
  }

  enterDescBox() {
    this.overDescDropdown = true;
  }

  leaveDescBox() {
    this.overDescDropdown = false;
  }

  enterHeaderServices() {
    this.overHeaderservices = true;
  }

  leaveHeaderServices() {
    this.overHeaderservices = false;
  }

  enterServicesBox() {
    this.overServicesDropdown = true;
  }

  leaveServicesBox() {
    this.overServicesDropdown = false;
  }
  copyLink() {
    const fixedLink = 'https://www.chemrobotics.com/registration';
    navigator.clipboard
      .writeText(fixedLink)
      .then(() => {
        alert('Link copied to clipboard!');
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
      });
  }
  copyToClipboarddemo() {
    const fixedUrl = 'https://www.chemrobotics.com/demo_request';
    navigator.clipboard
      .writeText(fixedUrl)
      .then(() => {
        this.copyMessage = 'The URL has been copied to your clipboard.';
        const copyToast = document.getElementById('copyToast');
        if (copyToast) {
          copyToast.classList.remove('hide');
          copyToast.classList.add('show');

          // Hide the toast after a few seconds
          setTimeout(() => {
            copyToast.classList.remove('show');
            copyToast.classList.add('hide');
          }, 3000); // Show for 3 seconds
        }
      })
      .catch((err) => {
        console.error('Failed to copy the URL: ', err);
      });
  }
  copyToClipboardsignup() {
    const fixedUrl = 'https://www.chemrobotics.com/registration';
    navigator.clipboard
      .writeText(fixedUrl)
      .then(() => {
        this.copyMessage = 'The URL has been copied to your clipboard.';
        const copyToast1 = document.getElementById('copyToast1');
        if (copyToast1) {
          copyToast1.classList.remove('hide');
          copyToast1.classList.add('show');

          setTimeout(() => {
            copyToast1.classList.remove('show');
            copyToast1.classList.add('hide');
          }, 3000);
        }
      })
      .catch((err) => {
        console.error('Failed to copy the URL: ', err);
      });
  }

  openMenu(value: boolean) {
    this.showMenu = value;
    this.selectedMenu = '';
    if (this.homePage) {
      if (this.showMenu) {
        this.transparent = false;
      } else {
        this.transparent = window.pageYOffset > 70 ? false : true;
      }
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.homePage && typeof window !== 'undefined') {
      if (this.showMenu) {
        this.transparent = false;
      } else {
        this.transparent = window?.pageYOffset > 70 ? false : true;
      }
    } else {
      this.transparent = false;
    }
  }

  togglePassword() {
    if (this.password === 'password') {
      this.password = 'text';
      this.show = true;
    } else {
      this.password = 'password';
      this.show = false;
    }
  }

  setIpandLocation() {
    this.datasearch.getIpandLocation().subscribe({
      next: (res) => {
        this.user_ip = res.userip;
        this.address = res.address;
      },
    });
  }
}
